import styled from "styled-components";

export const ScanQRCodeStyled = styled.div`
  position: relative;
  .scan_qr_container {
    margin: auto;
    border-radius: 21px;
    border: 0.5px solid ${({ theme }) => theme.COLORS.PURPLE_1};
    height: 40px;
    background: ${({ theme }) => theme.COLORS.WHITE_1};
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    .sq_block {
      width: 100%;
      padding: 0 20px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .sq_label {
        color: ${({ theme }) => theme.COLORS.PURPLE_1};
        font-size: ${({ theme }) => theme.FONT.SIZE.S13};
        font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_REGULAR};
      }
    }
  }
  .or_divider {
    display: flex;
    align-items: center;
    gap: 12px;
    margin: 16px 0;
    .or_line {
      flex: 1;
      height: 1px;
      background: transparent;
      opacity: 0.4;
    }
    .or_text {
      color: ${({ theme }) => theme.COLORS.PURPLE_1};
      font-size: ${({ theme }) => theme.FONT.SIZE.S14};
      font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_REGULAR};
    }
  }
  .upload_qr_container {
    margin-top: 0;
  }
  .theme_standard {
  }
`;
